export default __webpack_public_path__ + "assets/front/scss/classification-browsing.b656591f25d7e9aecd4fdbeb657e4c6c.css";